var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment method icon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mastercard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Left",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1791 16.8306C15.9951 17.8287 14.4591 18.4312 12.7807 18.4312C9.03582 18.4312 6 15.4316 6 11.7312C6 8.03094 9.03582 5.03125 12.7807 5.03125C14.4591 5.03125 15.9951 5.6338 17.1791 6.63192C18.3632 5.6338 19.8992 5.03125 21.5776 5.03125C25.3224 5.03125 28.3583 8.03094 28.3583 11.7312C28.3583 15.4316 25.3224 18.4312 21.5776 18.4312C19.8992 18.4312 18.3632 17.8287 17.1791 16.8306Z",
    fill: "#ED0006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1797 16.8306C18.6375 15.6017 19.5619 13.7731 19.5619 11.7312C19.5619 9.68937 18.6375 7.86082 17.1797 6.63192C18.3638 5.6338 19.8997 5.03125 21.5781 5.03125C25.323 5.03125 28.3588 8.03094 28.3588 11.7312C28.3588 15.4316 25.323 18.4312 21.5781 18.4312C19.8997 18.4312 18.3638 17.8287 17.1797 16.8306Z",
    fill: "#F9A000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Middle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1791 16.8306C18.637 15.6017 19.5614 13.7732 19.5614 11.7313C19.5614 9.68941 18.637 7.86086 17.1791 6.63196C15.7213 7.86086 14.7969 9.68941 14.7969 11.7313C14.7969 13.7732 15.7213 15.6017 17.1791 16.8306Z",
    fill: "#FF5E00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.1eb8069f9978ae7f3ff0d77447afa461.svg";
export { ForwardRef as ReactComponent };